import FallbackImageOptions from "%/dynamic-components/render-engine/bundles/fallback-image-options";
import FallbackImage from "%/dynamic-components/render-engine/options/image-options/fallback-image";
import {
  StandardImageElementMixin,
} from "%/dynamic-components/render-engine/components/production/elements/image-element/standard-image-element-mixin";
import LinkAction from "%/dynamic-components/render-engine/options/click-actions/link-action";
import {
  OptionMediaResolverMixin,
} from "%/dynamic-components/render-engine/mixins/production/option-media-resolver-mixin";

export const FallbackImageElementMixin = {
  mixins: [StandardImageElementMixin, OptionMediaResolverMixin],
  optionBundles: [
    FallbackImageOptions,
  ],
  options: [
    LinkAction,
  ],
  data() {
    return {
      FallbackImage,
    };
  },
  computed: {
    imageMediaUnresolvable() {
      return this.isOptionMediaUnresolvable(this.getOptionValue(FallbackImage));
    },
    imageSrc() {
      return this.resolveOptionMedia(this.getOptionValue(FallbackImage));
    },
    fallbackImageSrc() {
      return this.resolveOptionMedia(this.getOptionValue(FallbackImage));
    },
  },
};
